<ng-container *ngIf="userForm">
	<div class="main-content">
		<div class="container-fluid">
			<div class="row m-0 p-0">
				<div class="col-md-12 m-0 p-0">
					<div class="card">
						<div class="card-header card-header-{{color}}-2">
							<h4 class="card-title"> <i class="material-icons" (click)="back()">arrow_left</i>Edit Profile</h4>
							<p class="card-category text-right">Update your profile</p>
						</div>
						<div class="card-body">
							<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent">
								<mat-tab label="Profile">
									<form [formGroup]="userForm" class="text-dark mt-3 profile-form" (submit)="updateUser()">
										<div class="card card-body">
											<div class="row">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>User Id</mat-label>
														<input matInput formControlName="userid">
													</mat-form-field>
												</div>
												<div class="col-md-6" [ngClass]="isPosUser ? 'd-none' : ''">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Password</mat-label>
														<input matInput formControlName="password" type="password">
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Name</mat-label>
														<input matInput formControlName="realname">
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Email address</mat-label>
														<input matInput formControlName="email" type="email">
													</mat-form-field>
												</div>
											</div>

											<div class="row mt-3">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Phone#</mat-label>
														<input matInput formControlName="phone" type="tel">
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Default Location</mat-label>
														<mat-select formControlName="defaultlocation">
															<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
																{{ loc.loccode }} - {{ loc.locationname }}
															</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>

											<!-- Full Access Section -->
											<div class="row mt-3" *ngIf="user.fullaccess == '8'">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Full Access</mat-label>
														<input matInput formControlName="fullaccess" type="text">
													</mat-form-field>
												</div>
											</div>

											<!-- Additional Settings -->
											<div class="row mt-3" *ngIf="user.fullaccess == '8'">
												<div class="col-md-3">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Customer Admin</mat-label>
														<mat-select formControlName="customeradmin">
															<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div class="col-md-3">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Create Tender</mat-label>
														<mat-select formControlName="cancreatetender">
															<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div class="col-md-3">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Edit Inventory</mat-label>
														<mat-select formControlName="editinv">
															<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div class="col-md-3">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Dispatch Admin</mat-label>
														<mat-select formControlName="dispatchadmin">
															<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>

											<!-- Color Picker -->
											<div class="row mt-4 mb-4 text-center">
												<div class="col-12">
													<label class="color-label">Color Schema</label>
													<div class="profile-plugin switch-trigger active-color">
													  <span class="badge filter badge-purple"
															data-color="purple"
															[ngClass]="{'active': color === 'purple'}"
															(click)="changColor('purple')">
													  </span>
													  
													  <span class="badge filter badge-azure"
															data-color="azure"
															[ngClass]="{'active': color === 'azure'}"
															(click)="changColor('azure')">
													  </span>
													  
													  <span class="badge filter badge-green"
															data-color="green"
															[ngClass]="{'active': color === 'green'}"
															(click)="changColor('green')">
													  </span>
													
													  <span class="badge filter badge-red"
															data-color="red"
															[ngClass]="{'active': color === 'red'}"
															(click)="changColor('red')">
													  </span>
													</div>
												</div>


											</div>

											<!-- Submit Button -->
											<div class="row">
												<div class="col-12 text-right">
													<button mat-raised-button type="submit" color="primary" class="update-button">Update Profile</button>
												</div>
											</div>
										</div>

									</form>
								</mat-tab>



								<mat-tab label="Printers">
									<div class="col-12 mb-4">
										<mat-accordion class="w-100">
											<mat-expansion-panel [expanded]="true">
												<mat-expansion-panel-header>
													<mat-panel-title>Printer Setup Guide</mat-panel-title>
												</mat-expansion-panel-header>
									
												<div class="p-3">
													<ol class="pl-3">
														<li>
															Open <strong>Print Connect</strong> on this computer. Note the
															<strong>Machine Name</strong> shown at the top of the window.
															(That’s the name you must choose here.)														</li>
														<li>
															In <strong>Available Devices</strong>, pick the device whose name
															<strong>exactly matches</strong> the Machine Name shown in Print Connect,
															then select the correct <strong>Device Types</strong> (Invoice, Label, Receipt)
															and click <strong>➕ Add</strong>.
														</li>
														<li>
															Your selection appears under <strong>User Devices</strong>. If the
															<strong>same printer appears twice</strong>, it will print twice for every job.
															Keep only one entry.
														</li>
													</ol>
									
													<div class="mt-3">
														<p class="m-0"><strong>Does it need to be on the same network?</strong> No — it just needs to be set up on <em>this</em> computer.</p>
														<p class="m-0 text-danger"><strong>Nothing listed? Nothing prints.</strong> If no printers are listed in <em>User Devices</em>, no jobs will be sent.</p>
														<p class="m-0">
															<strong>Having trouble or shows “Disconnected/Reconnecting”?</strong>
															Refresh the page you’re printing from. (The header shows the live connection status.)
														</p>
													</div>
												</div>
											</mat-expansion-panel>
										</mat-accordion>
									</div>
									
									<div class="row m-0 p-0 mt-4">

										<!-- Available Devices Section -->
										<div class="col-md-6">
											<div class="section-header d-flex justify-content-between align-items-center">
												<h5 class="mat-title">Available Devices</h5>
											</div>
											<mat-divider></mat-divider>

											<!-- Search Box for Available Devices -->
											<mat-form-field appearance="outline" class="search-field w-100 mt-3">
												<mat-label>Search Available Devices</mat-label>
												<input matInput [(ngModel)]="searchAvailableDevices" placeholder="Search devices">
												<button mat-icon-button matSuffix (click)="searchAvailableDevices = ''" matTooltip="Clear search">
													<mat-icon>clear</mat-icon>
												</button>
											</mat-form-field>

											<!-- Available Devices as Cards -->
											<div *ngIf="filteredAvailableDevices().length === 0" class="text-center mt-4">
												<p class="text-muted">No printers available.</p>
											</div>

											<div class="row mt-3">
												<div class="col-sm-12" *ngFor="let device of filteredAvailableDevices()">
													<mat-card class="device-card mb-3 p-3 shadow-sm">
														<div class="d-flex justify-content-between align-items-center card-content">

															<!-- Device Name and IP on the Left -->
															<div class="device-info">
																<mat-card-title class="font-weight-bold">{{ device.machine_name }}</mat-card-title>
																<mat-card-subtitle class="text-muted">{{ device.ip }}</mat-card-subtitle>
																<p class="mb-1">
																	<small class="text-secondary">User: {{ device.machine_user }}</small>
																</p>
															</div>

															<!-- Device Types Selector and Add Button on the Right -->
															<div class="device-actions d-flex align-items-center">
																<mat-form-field appearance="outline" class="device-type-selector mr-2 full-width">
																	<mat-label>Device Types</mat-label>
																	<mat-select multiple [(ngModel)]="selectedDeviceTypes[device.device_id + '_' + device.machine_name]" placeholder="Select device types">
																		<mat-option *ngFor="let type of deviceTypes" [value]="type">{{ type }}</mat-option>
																	</mat-select>
																</mat-form-field>
																<button mat-raised-button color="primary" class="ml-2" (click)="addUserDevice(device)" matTooltip="Add Device">
																	<mat-icon>add</mat-icon>
																</button>
															</div>
														</div>
													</mat-card>
												</div>
											</div>

										</div>

										<!-- User Devices Section -->
										<div class="col-md-6">
											<h5 class="mat-title">User Devices</h5>
											<mat-divider></mat-divider>

											<!-- Search Box for User Devices -->
											<mat-form-field appearance="outline" class="search-field w-100 mt-3">
												<mat-label>Search User Devices</mat-label>
												<input matInput [(ngModel)]="searchUserDevices" placeholder="Search user devices">
												<button mat-icon-button matSuffix (click)="searchUserDevices = ''" matTooltip="Clear search">
													<mat-icon>clear</mat-icon>
												</button>
											</mat-form-field>

											<!-- User Devices as Cards -->
											<div *ngIf="filteredUserDevices().length === 0" class="text-center mt-4">
												<p class="text-muted">No user printers set.</p>
											</div>

											<div class="row mt-3">
												<div class="col-sm-12" *ngFor="let device of filteredUserDevices()">
													<mat-card class="device-card mb-3 p-3 shadow-sm">
														<div class="d-flex justify-content-between align-items-center card-content">

															<!-- Device Name, IP, and Device ID on the Left -->
															<div class="device-info">
																<mat-card-title class="font-weight-bold">{{ device.machineName }}</mat-card-title>
																<mat-card-subtitle class="text-muted">{{ device.machineUser }}</mat-card-subtitle>
															</div>

															<!-- Print Types Selector and Remove Button on the Right -->
															<div class="device-actions d-flex align-items-center">
																<mat-form-field appearance="outline" class="device-type-selector mr-2 full-width">
																	<mat-label>Print Types</mat-label>
																	<mat-select multiple [(ngModel)]="device.deviceTypes" (selectionChange)="updatePrintSettings(device.deviceID, device.machineName, device.deviceTypes)" placeholder="Select print types">
																		<mat-option *ngFor="let type of deviceTypes" [value]="type">{{ type }}</mat-option>
																	</mat-select>
																</mat-form-field>
																<button mat-raised-button color="warn" class="ml-2" (click)="removeUserDevice(device)" matTooltip="Remove Device">
																	<mat-icon>delete</mat-icon>
																</button>
															</div>
														</div>
													</mat-card>
												</div>
											</div>

										</div>
									</div>
								</mat-tab>

								<mat-tab label="Terminals">
									<div class="col-12 mb-4">
										<mat-accordion class="w-100">
											<mat-expansion-panel [expanded]="true">
												<mat-expansion-panel-header>
													<mat-panel-title>Terminal Setup Guide</mat-panel-title>
												</mat-expansion-panel-header>
									
												<div class="p-3">
													<ol class="pl-3">
														<li>
															Open <strong>Print Connect</strong> on this computer and go to the
															<strong>Terminals</strong> tab. Connect your payment terminal there first.
														</li>
														<li>
															In <strong>Available Terminals</strong> below, find the terminal you want to use
															and click <strong>➕ Add</strong> to assign it to your profile.
														</li>
														<li>
															Your selection appears under <strong>My Terminals</strong>. 
															This terminal will be used for card payments in POS.
														</li>
													</ol>
									
													<div class="mt-3">
														<p class="m-0"><strong>Terminal not showing?</strong> Make sure Print Connect is running and the terminal is connected in its Terminals tab.</p>
													</div>
												</div>
											</mat-expansion-panel>
										</mat-accordion>
									</div>
									
									<div class="row m-0 p-0 mt-4">

										<!-- Available Terminals Section -->
										<div class="col-md-6">
											<div class="section-header d-flex justify-content-between align-items-center">
												<h5 class="mat-title">Available Terminals</h5>
												<button mat-icon-button (click)="refreshCompanyTerminals()" matTooltip="Refresh list">
													<mat-icon>refresh</mat-icon>
												</button>
											</div>
											<mat-divider></mat-divider>

											<div *ngIf="(company_terminals || []).length === 0" class="text-center mt-4">
												<p class="text-muted">No terminals available. Connect a terminal in Print Connect first, then refresh.</p>
											</div>

											<div class="row mt-3">
												<div class="col-sm-12" *ngFor="let terminal of getAvailableTerminals()">
													<div class="terminal-list-item mb-3">
														<div class="d-flex justify-content-between align-items-start" *ngIf="editingTerminalId !== terminal.terminal_id">
															<div class="terminal-info flex-grow-1">
																<h6 class="terminal-name mb-1">{{ terminal.terminal_name }}</h6>
																<div class="terminal-details text-muted small">
																	<span *ngIf="terminal.machine_name || terminal.machine_user">
																		Machine: {{ terminal.machine_name || '—' }} | User: {{ terminal.machine_user || '—' }}
																	</span>
																	<span *ngIf="terminal.machine_name || terminal.machine_user" class="mx-1">•</span>
																	<span>{{ terminal.terminal_type === 'td_tetra' ? 'TD Bank' : terminal.terminal_type === 'ingenico' ? 'Ingenico' : terminal.terminal_type }}</span>
																	<span class="mx-1">•</span>
																	<span>{{ terminal.connection_type | uppercase }}</span>
																</div>
																<div class="terminal-meta text-muted small mt-1" *ngIf="terminal.terminal_model || terminal.terminal_serial">
																	<span *ngIf="terminal.terminal_model && terminal.terminal_model !== 'unknown'">
																		Model: {{ terminal.terminal_model === 'imove5000' ? 'iMove 5000' : terminal.terminal_model === 'desk5000' ? 'Desk 5000' : terminal.terminal_model }}
																	</span>
																	<span *ngIf="terminal.terminal_model && terminal.terminal_serial && terminal.terminal_serial !== 'UNKNOWN' && terminal.terminal_serial !== 'unknown'" class="mx-1">•</span>
																	<span *ngIf="terminal.terminal_serial && terminal.terminal_serial !== 'UNKNOWN' && terminal.terminal_serial !== 'unknown'">
																		Serial: {{ terminal.terminal_serial }}
																	</span>
																</div>
															</div>
															<div class="terminal-actions">
																<button mat-icon-button (click)="startEditTerminal(terminal)" matTooltip="Edit name">
																	<mat-icon>edit</mat-icon>
																</button>
																<button mat-mini-fab color="primary" (click)="addUserTerminal(terminal)" matTooltip="Add Terminal">
																	<mat-icon>add</mat-icon>
																</button>
															</div>
														</div>
														<div class="terminal-edit-form" *ngIf="editingTerminalId === terminal.terminal_id">
															<mat-form-field appearance="outline" class="w-100 mb-2">
																<mat-label>Terminal name</mat-label>
																<input matInput [(ngModel)]="editTerminalName">
															</mat-form-field>
															<mat-form-field appearance="outline" class="w-100 mb-2">
																<mat-label>Machine name</mat-label>
																<input matInput [(ngModel)]="editMachineName">
															</mat-form-field>
															<mat-form-field appearance="outline" class="w-100 mb-2">
																<mat-label>Machine user</mat-label>
																<input matInput [(ngModel)]="editMachineUser">
															</mat-form-field>
															<div class="d-flex gap-2">
																<button mat-raised-button color="primary" (click)="saveTerminalEdit()">Save</button>
																<button mat-button (click)="cancelTerminalEdit()">Cancel</button>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<!-- My Terminals Section -->
										<div class="col-md-6">
											<div class="section-header d-flex justify-content-between align-items-center">
												<h5 class="mat-title">My Terminals</h5>
											</div>
											<mat-divider></mat-divider>

											<div *ngIf="(user_terminals || []).length === 0" class="text-center mt-4">
												<p class="text-muted">No terminals assigned to your profile.</p>
											</div>

											<div class="row mt-3">
												<div class="col-sm-12" *ngFor="let terminal of user_terminals">
													<div class="terminal-list-item terminal-assigned mb-3">
														<div class="d-flex justify-content-between align-items-start" *ngIf="editingTerminalId !== terminal.terminal_id">
															<div class="terminal-info flex-grow-1">
																<h6 class="terminal-name mb-1">{{ terminal.terminal_name }}</h6>
																<div class="terminal-details text-muted small">
																	<span *ngIf="terminal.machine_name || terminal.machine_user">
																		Machine: {{ terminal.machine_name || '—' }} | User: {{ terminal.machine_user || '—' }}
																	</span>
																	<span *ngIf="terminal.machine_name || terminal.machine_user" class="mx-1">•</span>
																	<span>{{ terminal.terminal_type === 'td_tetra' ? 'TD Bank' : terminal.terminal_type === 'ingenico' ? 'Ingenico' : terminal.terminal_type }}</span>
																</div>
															</div>
															<div class="terminal-actions">
																<button mat-icon-button (click)="startEditTerminal(terminal)" matTooltip="Edit name">
																	<mat-icon>edit</mat-icon>
																</button>
																<button mat-mini-fab color="warn" (click)="removeUserTerminal(terminal)" matTooltip="Remove Terminal">
																	<mat-icon>delete</mat-icon>
																</button>
															</div>
														</div>
														<div class="terminal-edit-form" *ngIf="editingTerminalId === terminal.terminal_id">
															<mat-form-field appearance="outline" class="w-100 mb-2">
																<mat-label>Terminal name</mat-label>
																<input matInput [(ngModel)]="editTerminalName">
															</mat-form-field>
															<mat-form-field appearance="outline" class="w-100 mb-2">
																<mat-label>Machine name</mat-label>
																<input matInput [(ngModel)]="editMachineName">
															</mat-form-field>
															<mat-form-field appearance="outline" class="w-100 mb-2">
																<mat-label>Machine user</mat-label>
																<input matInput [(ngModel)]="editMachineUser">
															</mat-form-field>
															<div class="d-flex gap-2">
																<button mat-raised-button color="primary" (click)="saveTerminalEdit()">Save</button>
																<button mat-button (click)="cancelTerminalEdit()">Cancel</button>
															</div>
														</div>
													</div>
												</div>
											</div>
							
							<div class="row m-0 p-0 mt-4">
								<div class="col-12">
									<div class="card">
										<div class="card-header d-flex justify-content-between align-items-center">
											<h5 class="mat-title mb-0">Batch & Sync</h5>
										</div>
										<div class="card-body">
											<div class="form-group mb-3">
												<label for="batchTerminalSelect" class="form-label">Terminal</label>
												<select id="batchTerminalSelect" class="form-control" [(ngModel)]="selectedBatchTerminalId" (change)="onBatchTerminalChange()">
													<option *ngFor="let terminal of user_terminals" [value]="terminal.terminal_id">
														{{ terminal.terminal_name || terminal.terminal_id }}
													</option>
												</select>
											</div>
											<div class="small text-muted mb-2">
												Pending sync:
												<span *ngIf="pendingSyncLoading">Loading...</span>
												<span *ngIf="!pendingSyncLoading">{{ pendingSyncCount }}</span>
											</div>
											<div class="text-danger small mb-2" *ngIf="pendingSyncError">{{ pendingSyncError }}</div>
											<div class="d-flex gap-2 mb-2">
												<button class="btn btn-outline-primary btn-sm" (click)="retryPendingSync()" [disabled]="pendingSyncLoading">Retry Sync</button>
												<button class="btn btn-outline-primary btn-sm" (click)="runBatchSubtotal()" [disabled]="batchInProgress">Batch Subtotal</button>
												<button class="btn btn-outline-danger btn-sm" (click)="runBatchClose()" [disabled]="batchInProgress">Batch Close</button>
											</div>
											<div class="small text-muted mt-2" *ngIf="batchResult && !batchResult.error">
												<span *ngIf="batchResult.batch_number">Batch {{ batchResult.batch_number }} • Balanced: {{ batchResult.batch_balanced ? 'Yes' : 'No' }}</span>
												<span *ngIf="!batchResult.batch_number">{{ batchResult.message || 'Batch completed' }}</span>
											</div>
											<div class="small text-danger mt-2" *ngIf="batchResult?.error">{{ batchResult.error }}</div>
										</div>
									</div>
								</div>
							</div>

										</div>
									</div>
								</mat-tab>

								<mat-tab label="Favorites">
									<div class="row m-0 p-0 mt-4">
										<div class="col-md-12">
										<button *ngIf="saveavailable" mat-raised-button color="success" class="ml-2" (click)="reorderFavorites()" matTooltip="Save Changes">
										<mat-icon>save</mat-icon> Save Changes and Reload
										</button>
										<div class="scrollable-table">
											<div *ngIf="favorites.length != 0">
												<div cdkDropList class="product-drop-list" (cdkDropListDropped)="drop($event)">
													<div *ngFor="let fave of favorites" class="product-drop-box" cdkDrag>
														<button mat-icon-button color="warn" (click)="removeFavorites(fave.faveid)">
															<mat-icon>delete</mat-icon>
														</button>
														<div class="item-info">
															<b>{{fave.title}}</b><br>
														</div>
													</div>
												</div>
											</div>
											<div class="no-results" *ngIf="favorites.length == 0">
												No Favorites Added
											</div>
										</div>
										</div>
									</div>
								</mat-tab>
								<mat-tab label='Dashboard Editor'>
									<ng-template matTabContent>
										<app-user-dashboard-editor></app-user-dashboard-editor>
									</ng-template>
								</mat-tab>
							</mat-tab-group>
						</div>
					</div>
				</div>
				<div class="col-md-4 d-none">
					<div class="card card-profile">
						<div class="card-avatar">
							<a href="javascript:void(0)">
								<img class="img" src="./assets/img/faces/marc.jpg" />
							</a>
						</div>
						<div class="card-body">
							<h6 class="card-category text-gray">CEO / Co-Founder</h6>
							<h4 class="card-title">{{ userdetails.realname }}</h4>
							<p class="card-description">
								Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
							</p>
							<a href="javascript:void(0)" class="btn btn-danger btn-round">Follow</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>